module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "goods-box"
  }, [_c('div', {
    staticClass: "goods-banner-fill"
  }, [_c('van-swipe', {
    ref: "swipe",
    attrs: {
      "indicator-color": "#FD2840",
      "duration": _vm.duration,
      "loop": _vm.loop
    },
    on: {
      "change": _vm.onSwipeChange
    }
  }, [(_vm.detail.videos_url) ? _c('van-swipe-item', {
    on: {
      "click": _vm.toGoodsVideo
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.detail.videos_url),
      expression: "detail.videos_url"
    }],
    attrs: {
      "src": _vm.detail.videos_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "video-img",
    attrs: {
      "src": require("../../../assets/images/icon-video-play.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.detail.pics_url), function(item) {
    return _c('van-swipe-item', {
      key: item.id
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), _vm._v(" "), (_vm.picCount > 0) ? _c('van-swipe-item', [_c('div', {
    staticClass: "swipe-text"
  }, [_vm._v("继续滑动查看图文详情")])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "goods-pri"
  }, [_c('div', {
    staticClass: "goods-price-top"
  }, [_c('div', {
    staticClass: "goods-price"
  }, [_c('div', {
    staticClass: "goods-price1"
  }, [_vm._v("¥")]), _vm._v(" "), _c('div', {
    staticClass: "goods-price2"
  }, [_vm._v(_vm._s(_vm.detail.price_range_1))]), _vm._v(" "), (_vm.detail.price_range_2) ? _c('div', {
    staticClass: "goods-price1"
  }, [_vm._v("\n              ." + _vm._s(_vm.detail.price_range_2) + "\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.detail.max_seller_reward > 0) ? _c('div', {
    staticClass: "scroll-goods-item0-seller-price",
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('div', {
    staticClass: "fan"
  }, [_vm._v("赚")]), _vm._v(" "), _c('div', {
    staticClass: "seller-price"
  }, [_vm._v("¥" + _vm._s(_vm.detail.max_seller_reward))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row-left"
  }, [_vm._v("\n          已售 " + _vm._s(_vm.detail.sold_count + _vm.detail.sold_show_count) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "goods-name show-two-row"
  }, [_vm._v(_vm._s(_vm.detail.title))]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.detail.credit_limit > 0) ? _c('div', {
    staticStyle: {
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "clear to-buy-vip-box"
  }, [_c('div', {
    staticClass: "buy-vip-msg-box hide-txt"
  }, [_c('div', {
    staticClass: "buy-vip-msg hide-txt"
  }, [_vm._v("\n              使用积分立减" + _vm._s(_vm.detail.credit_limit) + "元\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'cmsDetail',
        query: {
          type: 'help',
          id: 5
        }
      }),
      expression: "{ name: 'cmsDetail', query: { type: 'help', id: 5 } }"
    }],
    staticClass: "to-buy-vip"
  }, [_vm._v("\n            获取积分\n            "), _c('span', {
    staticClass: "arrow-by-border"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "share-box share-right"
  }, [(_vm.detail.max_seller_reward > 0) ? _c('div', {
    staticClass: "share-right-text",
    on: {
      "click": _vm.getShare
    }
  }, [_vm._v("\n          分享好友可赚\n          "), _c('div', [_vm._v("￥" + _vm._s(_vm.detail.max_seller_reward))])]) : _c('div', {
    staticClass: "share-right-texts",
    on: {
      "click": _vm.getShare
    }
  }, [_vm._v("\n          分享给好友\n        ")])]), _vm._v(" "), (_vm.detail.discount_tags.length > 0) ? _c('div', {
    staticClass: "row-tips"
  }, [_c('GoodsDetailTips', {
    attrs: {
      "discount": _vm.detail.discount_tags
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row-list app-border-top"
  }, _vm._l((_vm.detail.extra_data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "app-border-bottom flex-between row-one"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.music.length > 0),
      expression: "detail.music.length > 0"
    }],
    staticClass: "detail-content"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("试听音乐")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "music-list"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active": _vm.mp3Active,
      "active-icon": "checked",
      "inactive-icon": "circle"
    }
  }, _vm._l((_vm.detail.music), function(item, i) {
    return _c('van-step', {
      key: i
    }, [_c('p', {
      staticClass: "course-title",
      on: {
        "click": function($event) {
          return _vm.onPlayItems(i)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "course-info",
      on: {
        "click": function($event) {
          return _vm.onPlayItems(i)
        }
      }
    }, [_vm._v("点击播放")])])
  }), 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail-img",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loveGoods.length > 0),
      expression: "loveGoods.length > 0"
    }],
    staticClass: "detail-title"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("猜你喜欢")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#efefef",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "love_goods"
  }, _vm._l((_vm.loveGoods), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "love_goods_items",
      on: {
        "click": function($event) {
          return _vm.getLoveGoods(item.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "love_goods_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "goods-price",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_c('div', {
      staticClass: "goods-price1"
    }, [_vm._v("¥")]), _vm._v(" "), _c('div', {
      staticClass: "goods-price2"
    }, [_vm._v(_vm._s(item.price_range_1))]), _vm._v(" "), (item.price_range_2) ? _c('div', {
      staticClass: "goods-price1"
    }, [_vm._v("\n                ." + _vm._s(item.price_range_2) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-price-thr gray-light",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [_vm._v("\n              ¥" + _vm._s(_vm._f("price")(item.orig_price)) + "\n            ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-footer"
  }, [_c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "height": "60px",
      "padding": "0 15px"
    }
  }, [_c('div', {
    staticClass: "goods-action-left"
  }, [_c('div', {
    staticClass: "action-left-icon-box",
    on: {
      "click": _vm.goHome
    }
  }, [_c('img', {
    staticClass: "icon-goods-detail",
    attrs: {
      "mode": "widthFix",
      "src": "https://static.dierqudao.com/images/vfd/icon-detail-hone.png"
    }
  }), _vm._v("\n          首页\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "action-left-icon-box",
    on: {
      "click": _vm.onChat
    }
  }, [_c('img', {
    staticClass: "icon-goods-detail",
    attrs: {
      "mode": "widthFix",
      "src": "https://static.dierqudao.com/images/vfd/icon-detail-kefu.png"
    }
  }), _vm._v("客服\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "action-left-icon-box",
    on: {
      "click": _vm.goCart
    }
  }, [_c('img', {
    staticClass: "icon-goods-detail",
    attrs: {
      "mode": "widthFix",
      "src": "https://static.dierqudao.com/images/vfd/icon-detail-cart.png"
    }
  }), _vm._v("购物车\n          "), (_vm.cart_count > 0) ? _c('div', {
    staticClass: "action-cart-count"
  }, [_vm._v("\n            " + _vm._s(_vm.cart_count) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "buys-box"
  }, [_c('div', {
    staticClass: "goods-add-cart",
    on: {
      "click": function($event) {
        _vm.showSkuPicker = true
      }
    }
  }, [_vm._v("\n          加入购物车\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "goods-buy",
    on: {
      "click": function($event) {
        _vm.showSkuPicker = true
      }
    }
  }, [_vm._v("立刻购买")])])])]), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.onShareCancel
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sku-container"
  }, [_c('van-sku', {
    attrs: {
      "sku": _vm.skuData.sku,
      "goods": _vm.skuData.goods,
      "goods-id": _vm.skuData.goods_id,
      "quota": _vm.skuData.quota,
      "quota-used": _vm.skuData.quotaUsed,
      "properties": _vm.skuData.properties,
      "custom-stepper-config": _vm.customStepperConfig,
      "hide-stock": _vm.skuData.hide_stock,
      "close-on-click-overlay": _vm.closeOnClickOverlay,
      "message-config": _vm.messageConfig
    },
    on: {
      "buy-clicked": _vm.onBuyClicked,
      "add-cart": _vm.onAddCartClicked
    },
    model: {
      value: (_vm.showSkuPicker),
      callback: function($$v) {
        _vm.showSkuPicker = $$v
      },
      expression: "showSkuPicker"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('ShareDialog', {
    attrs: {
      "show": _vm.shareShow,
      "reward": _vm.detail.max_seller_reward,
      "goods_id": _vm.detail.id,
      "share": _vm.share
    },
    on: {
      "shareCancel": _vm.shareCancel
    }
  }), _vm._v(" "), _c('ActivityDialog', {
    attrs: {
      "row": _vm.detail.activity
    }
  }), _vm._v(" "), _c('BookDialog', {
    attrs: {
      "show": _vm.bookDialogShow,
      "wxNote": _vm.chat.note,
      "wxCode": _vm.chat.wxcode,
      "wxPic": _vm.chat.pic_url,
      "phone": _vm.chat.phone
    },
    on: {
      "onBookCancle": _vm.onBookCancle
    }
  }), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "closeable": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showMusic),
      callback: function($$v) {
        _vm.showMusic = $$v
      },
      expression: "showMusic"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.playMusicUrl && _vm.showMusic) ? _c('audio', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "autoplay": "",
      "src": _vm.playMusicUrl,
      "controls": "controls"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 0 0"
    }
  }, [_vm._v(_vm._s(_vm.playMusicName))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-label"
  }, [_c('div', [_vm._v("·正品保证")]), _vm._v(" "), _c('div', [_vm._v("·极速发货")]), _vm._v(" "), _c('div', [_vm._v("·超值底价")]), _vm._v(" "), _c('div', [_vm._v("·售后无忧")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-content",
    attrs: {
      "id": "detail"
    }
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("商品详情")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fb5bbd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsDetail.vue
// module id = 2388
// module chunks = 0